var map = {
	"./3d_4.png": 15894,
	"./3d_5.png": 12223,
	"./Memoji-01.png": 23955,
	"./Memoji-02.png": 49464,
	"./Memoji-03.png": 17729,
	"./Memoji-04.png": 81614,
	"./Memoji-05.png": 24631,
	"./Memoji-06.png": 40348,
	"./Memoji-07.png": 53413,
	"./Memoji-08.png": 22818,
	"./Memoji-09.png": 43947,
	"./Memoji-10.png": 38645,
	"./Memoji-11.png": 69548,
	"./Memoji-12.png": 89607,
	"./Memoji-13.png": 71294,
	"./Memoji-14.png": 12305,
	"./Memoji-15.png": 14440,
	"./Memoji-16.png": 99715,
	"./Memoji-17.png": 82138,
	"./Memoji-18.png": 81997,
	"./Memoji-19.png": 42052,
	"./Memoji-20.png": 89456,
	"./Memoji-21.png": 95705,
	"./Memoji-22.png": 29122,
	"./Memoji-23.png": 3275,
	"./Memoji-24.png": 53364,
	"./Memoji-25.png": 74493,
	"./Memoji-26.png": 93286,
	"./memo_1.png": 14908,
	"./memo_10.png": 28934,
	"./memo_11.png": 10479,
	"./memo_12.png": 89012,
	"./memo_13.png": 10141,
	"./memo_14.png": 48418,
	"./memo_15.png": 38923,
	"./memo_16.png": 25104,
	"./memo_17.png": 31353,
	"./memo_18.png": 41966,
	"./memo_19.png": 41463,
	"./memo_2.png": 3639,
	"./memo_20.png": 71863,
	"./memo_21.png": 26286,
	"./memo_22.png": 96645,
	"./memo_23.png": 91375,
	"./memo_24.png": 68627,
	"./memo_25.png": 29770,
	"./memo_26.png": 44001,
	"./memo_27.png": 22872,
	"./memo_28.png": 47823,
	"./memo_29.png": 25158,
	"./memo_3.png": 13646,
	"./memo_30.png": 58892,
	"./memo_31.png": 70517,
	"./memo_32.png": 33790,
	"./memo_33.png": 9575,
	"./memo_34.png": 29960,
	"./memo_35.png": 78353,
	"./memo_4.png": 96737,
	"./memo_5.png": 24024,
	"./memo_6.png": 98515,
	"./memo_7.png": 47754,
	"./memo_8.png": 24349,
	"./memo_9.png": 3220,
	"assets/images/avatars/3d_4.png": 15894,
	"assets/images/avatars/3d_5.png": 12223,
	"assets/images/avatars/Memoji-01.png": 23955,
	"assets/images/avatars/Memoji-02.png": 49464,
	"assets/images/avatars/Memoji-03.png": 17729,
	"assets/images/avatars/Memoji-04.png": 81614,
	"assets/images/avatars/Memoji-05.png": 24631,
	"assets/images/avatars/Memoji-06.png": 40348,
	"assets/images/avatars/Memoji-07.png": 53413,
	"assets/images/avatars/Memoji-08.png": 22818,
	"assets/images/avatars/Memoji-09.png": 43947,
	"assets/images/avatars/Memoji-10.png": 38645,
	"assets/images/avatars/Memoji-11.png": 69548,
	"assets/images/avatars/Memoji-12.png": 89607,
	"assets/images/avatars/Memoji-13.png": 71294,
	"assets/images/avatars/Memoji-14.png": 12305,
	"assets/images/avatars/Memoji-15.png": 14440,
	"assets/images/avatars/Memoji-16.png": 99715,
	"assets/images/avatars/Memoji-17.png": 82138,
	"assets/images/avatars/Memoji-18.png": 81997,
	"assets/images/avatars/Memoji-19.png": 42052,
	"assets/images/avatars/Memoji-20.png": 89456,
	"assets/images/avatars/Memoji-21.png": 95705,
	"assets/images/avatars/Memoji-22.png": 29122,
	"assets/images/avatars/Memoji-23.png": 3275,
	"assets/images/avatars/Memoji-24.png": 53364,
	"assets/images/avatars/Memoji-25.png": 74493,
	"assets/images/avatars/Memoji-26.png": 93286,
	"assets/images/avatars/memo_1.png": 14908,
	"assets/images/avatars/memo_10.png": 28934,
	"assets/images/avatars/memo_11.png": 10479,
	"assets/images/avatars/memo_12.png": 89012,
	"assets/images/avatars/memo_13.png": 10141,
	"assets/images/avatars/memo_14.png": 48418,
	"assets/images/avatars/memo_15.png": 38923,
	"assets/images/avatars/memo_16.png": 25104,
	"assets/images/avatars/memo_17.png": 31353,
	"assets/images/avatars/memo_18.png": 41966,
	"assets/images/avatars/memo_19.png": 41463,
	"assets/images/avatars/memo_2.png": 3639,
	"assets/images/avatars/memo_20.png": 71863,
	"assets/images/avatars/memo_21.png": 26286,
	"assets/images/avatars/memo_22.png": 96645,
	"assets/images/avatars/memo_23.png": 91375,
	"assets/images/avatars/memo_24.png": 68627,
	"assets/images/avatars/memo_25.png": 29770,
	"assets/images/avatars/memo_26.png": 44001,
	"assets/images/avatars/memo_27.png": 22872,
	"assets/images/avatars/memo_28.png": 47823,
	"assets/images/avatars/memo_29.png": 25158,
	"assets/images/avatars/memo_3.png": 13646,
	"assets/images/avatars/memo_30.png": 58892,
	"assets/images/avatars/memo_31.png": 70517,
	"assets/images/avatars/memo_32.png": 33790,
	"assets/images/avatars/memo_33.png": 9575,
	"assets/images/avatars/memo_34.png": 29960,
	"assets/images/avatars/memo_35.png": 78353,
	"assets/images/avatars/memo_4.png": 96737,
	"assets/images/avatars/memo_5.png": 24024,
	"assets/images/avatars/memo_6.png": 98515,
	"assets/images/avatars/memo_7.png": 47754,
	"assets/images/avatars/memo_8.png": 24349,
	"assets/images/avatars/memo_9.png": 3220
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51632;